export function setupSorting(postType, containerEl, sortByWidget) {
    const config = window.snapFindPublic;
    const sortingConfig = config.frontend.sorting[postType] || [];
    const baseIndexName = `${config.server.collection_prefix}${postType}`;

    // Always provide relevance (default) as the first option
    const items = [{ label: 'Relevance', value: baseIndexName }];

    // Read configured sorting fields and convert them to Typesense pseudo-indices
    sortingConfig.forEach((option) => {
        // Typesense InstantSearch Adapter uses CollectionName/sort_field/sort_order
        // to handle dynamic indexing within the same collection.
        const dynamicIndex = `${baseIndexName}/sort/${option.field}:${option.order}`;
        items.push({
            label: option.label,
            value: dynamicIndex,
        });
    });

    return sortByWidget({
        container: containerEl,
        items: items,
    });
}
